var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component",staticClass:"epg-grid-view--full",attrs:{"channels":_vm.$section.products,"categories":_vm.availableCategories,"opts":_vm.opts}})
}
var staticRenderFns = []

export { render, staticRenderFns }